import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ManualPaymentModalComponent } from './manual-payment-modal.component';
import { ManualPaymentModalResolve } from './manual-payment-modal.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manual-payment-modal',
        component: ManualPaymentModalComponent,
        resolve: {
          portal: ManualPaymentModalResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class ManualPaymentModalRoutingModule {}
